import styled, { css } from 'styled-components'

export const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 24px;
  max-width: 1170px;

  .input-search {
    max-width: 100%;
  }

  .top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 32px;
    align-items: center;

    h1 {
      font-weight: 700;
      font-size: 32px;
      line-height: 39px;
    }

    .filterButtons {
      display: flex;
      align-items: center;
      gap: 32px;
      margin-top: 8px;
    }

    .filter-label {
      font-style: italic;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
    }

    .filter {
      display: flex;
      gap: 24px;
    }
  }

  .tags {
    width: 100%;
    flex-wrap: nowrap;
    display: flex;
    align-items: center;
    gap: 18px;
    overflow-x: auto;
    padding-bottom: 10px;
    padding-left: 10px;

    span {
      white-space: nowrap;
    }

    &::-webkit-scrollbar {
      height: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb:horizontal {
      background: #888;
      background-color: #888;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:horizontal:hover {
      background: #555;
    }
  }

  @media (max-width: 500px) {
    gap: 20px;
    .top {
      h1 {
        font-weight: ${({ theme }) => theme.fontWeights.regular};
        font-size: 20px;
      }
      .filter-label {
        display: none;
      }
    }
  }
`

type ButtonProps = {
  selected: boolean
}

export const Button = styled.button<ButtonProps>`
  all: unset;
  cursor: pointer;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  ${({ selected }) =>
    selected &&
    css`
      font-weight: ${({ theme }) => theme.fontWeights.bold};
      color: ${({ theme }) => theme.colors.primary};
      transform: scale(1.1);
    `}
`
